import { render, staticRenderFns } from "./c_home_comb.vue?vue&type=template&id=7fbdfc1c&scoped=true"
import script from "./c_home_comb.vue?vue&type=script&lang=js"
export * from "./c_home_comb.vue?vue&type=script&lang=js"
import style0 from "./c_home_comb.vue?vue&type=style&index=0&id=7fbdfc1c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbdfc1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fbdfc1c')) {
      api.createRecord('7fbdfc1c', component.options)
    } else {
      api.reload('7fbdfc1c', component.options)
    }
    module.hot.accept("./c_home_comb.vue?vue&type=template&id=7fbdfc1c&scoped=true", function () {
      api.rerender('7fbdfc1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_home_comb.vue"
export default component.exports